<template>
  <v-card color="secondary">
    <v-card-title>Simple V-Model Component</v-card-title>
    <v-card-text>

      <h3>The current value is:</h3>
      <pre style="color:red;font-size:1.5em;">{{value}}</pre>

      <br />

      These buttons force an <b>$emit("input",... )</b> to occur.
      <br />
      <v-btn @click="$emit('input', option)" v-for="(option,o) in options" :key="`option-${o}`">{{option}}</v-btn>

    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: 'VModelExample',
  components: {},
  props : {
    value : {type:String, default: ""},
  },
  computed : {
    options()
    {
      return [
        "LyondellBasell",
        "GoalZero",
        "Advancing Possible",
      ];
    }
  },

}
</script>

<style scoped lang="scss">
</style>
